import * as React from 'react';

const SvgIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill={props.fill || '#1D252D'} viewBox="0 -960 960 960">
    <path d="M162.31-130q-29.83 0-51.07-21.24T90-202.31v-613.46l57 57 66-67 67 67 67-67 66 67 67-67 67 67 66-67 67 67 67-67 66 67 57-57v613.46q0 29.83-21.24 51.07T797.69-130zm0-60H450v-260H150v247.69q0 5.39 3.46 8.85t8.85 3.46M510-190h287.69q5.39 0 8.85-3.46t3.46-8.85V-290H510zm0-160h300v-100H510zM150-510h660v-143.85H150z"></path>
  </svg>
);

export default SvgIcon;
